import Key from '../components/Key'

export default function Keyboard({ keyboard, onKeyPress }) {
  const KEYS = [
    ["A","Z","E","R","T","Y","U","I","O","P"],
    ["Q","S","D","F","G","H","J","K","L","M"],
    ["W","X","C","V","B","N","←"],
    ["Valider"]
  ];

  return (
    <div>
      {KEYS.map((line, i) => (
        <div key={'row_' +i} className='key' style={{ display: "flex", justifyContent: "center" }}>
          {line.map(k => (  
            <Key
              key={k}
              k={k}
              status={keyboard[k]}
              onClick={onKeyPress}
            />
          ))}
        </div>
      ))}
    </div>
  );
}